// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"47":"5e3ba67d","107":"43b123f5","224":"2d0347a6","246":"da585bec","389":"10e05a41","405":"43089d8a","411":"377d4826","472":"3dac30f7","482":"8e685d7e","521":"88fe295a","575":"314621aa","949":"43e7f5d6"}[chunkId] + ".chunk.js";
};